import { HttpClient } from '@angular/common/http';
import { Directive, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicePathsSettings } from '../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { FileFolders } from "../../components/fascicolo/documentazione-allegata-view/documentazione-allegata.component";
import { FileInputComponent } from '../../components/input-component/file-input/file-input.component';
import { DocumentoAllegato } from '../../models/documento-allegato';
import { FileData } from '../../models/file-data';
import { CensimentoDocumenti } from '../../models/sezioni/sezione-censimento-documenti/censimento-documenti';
import { Provenienza } from '../../models/tipologiche/provenienza';
import { TipoProvenienzaDocumento } from '../../models/tipologiche/tipi-provenienza-documento';
import { TipoDocumento } from '../../models/tipologiche/tipo-documento';
import { TipoTipologica } from '../../models/tipologiche/tipo-tipologica';
import { BaseForm } from '../base-Form';
import { ProtocolFindFascicoloRequest } from '../../protocol/models/dto/protocol-fascicolo';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { ProtocolFascicoloSearchComponent } from '../../protocol/components/fascicolo/search/protocol-fascicolo-search.component';
import { BehaviorSubject, forkJoin, from, map, Observable } from 'rxjs';
import { MetadatoDocumento } from './document-uploaded/campi';
import {VisibilitaDocumento} from '../../models/tipologiche/visibilita-documento';
import { UploadDocumentUtilityService } from './document-uploaded/upload-document-utility.service';

declare var closeModal: any;

@Directive()
export abstract class DocumentoAddFormAbstractComponent extends BaseForm {
  newRequest: DocumentoAllegato;
  formRequest: DocumentoAllegato;
  aggiungiDocumentoForm: FormGroup;
  public fileData: FileData = new FileData();
  tipiProvenienza: Provenienza[];
  tipiProvenienzaDocumento: TipoProvenienzaDocumento[];
  tipiDocumento: TipoDocumento[];
  tipiVisibilitaDocumento: VisibilitaDocumento[];
  disableSubmit: boolean = true;
  public editNameDir: boolean;
  public tipiCanaleOptions: TipoTipologica[] = [];
  public classi: TipoTipologica[] = [];
  public categorie: TipoTipologica[] = [];
  public categorieOrigin: TipoTipologica[] = [];
  public canaleSel: TipoTipologica;
  public classeSel: TipoTipologica;
  public categoriaSel: TipoTipologica;
  isSearchTabActive = true;

  contentFileArry: any = [];
  fileExport: any = [];
  secondStep: boolean = false;
  datiArchiView: boolean = false;
  provenienzaAtto: Provenienza;
  tipoAtto: any;
  isCensimentoDocumenti: boolean = false;
  requestCensimentoDocumenti: CensimentoDocumenti;

  archivioOptions: TipoTipologica[] = [];
  archivioSel: TipoTipologica;
  tipoDocArchiSel: TipoTipologica;
 // private fileSubject: Subject<DocumentoAllegato> = new Subject();
 // public fileObservable: Observable<DocumentoAllegato> = this.fileSubject.asObservable();
  private _uploadedFileList = new BehaviorSubject<DocumentoAllegato[]>([]);
  uploadedFileList = this._uploadedFileList.asObservable();
  @Output() onReturn: EventEmitter<any> = new EventEmitter();
  @Output() onReturnSpostaDoc = new EventEmitter();
  @ViewChild('uploadInput') uploadInput: ElementRef;
  @ViewChild('fileInputComponent') fileInputComponent: FileInputComponent;
  @ViewChild('searchItem') searchItemRef!: ElementRef;
  @ViewChild('protocolSearch') protocolSearch: ProtocolFascicoloSearchComponent;

  constructor(
    protected operationService: OperationsService,
    private campiForm: FormBuilder,
    public helperServices: HelpersService,
    public httpService: HttpClient,
    protected dialogRef: DialogRef,
    public viewManager: ViewManagerService,
    public uploadUtilityService: UploadDocumentUtilityService) {
    super();
  }

  getTipiProvenienza() {
    this.helperServices.getTipiProvenienzaDocumento().subscribe(response => {
      this.tipiProvenienza = (<Provenienza[]>response);
      this.setDefaultProvenienza();
    });
  }

  private setDefaultProvenienza(): void {
    if (!this.formRequest?.provenienza && this.tipiProvenienza?.length) {
      const interno = this.tipiProvenienza.find(p => p.label?.toUpperCase() === 'INTERNO');
      if (interno) {
        this.formRequest.provenienza = interno;
        this.aggiungiDocumentoForm?.get('provenienza')?.setValue(interno);
      }
    }
  }

  getTipiDocumento() {
    this.helperServices.getTipiDocumenti().subscribe(response => this.tipiDocumento = response && response.length>0 ? (response.sort((a, b)=>(a.label < b.label ) ? -1 : 1)) : []);
  }

  getTipiVisibilitaDocumento() {
    this.helperServices.getTipiVisibilitaDocumento().subscribe(response => {
      this.tipiVisibilitaDocumento = response;
      this.setDefaultVisibilitaDocumento();
    });
  }

  getUrlUploadDocumento() {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_DOCUMENTO;
  }


  createForm(entity?: any) {
    this.tipoAtto = null;
    this.provenienzaAtto = null;
    this.disableSubmit = true;
    if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
    if (this.protocolSearch) {
      this.protocolSearch.onReset();
    }
    this.fileUploadList = [];
    this.formRequest = new DocumentoAllegato();
    this.formRequest.flagOcr = true;
    this.formRequest.titolo = null;
    this.formRequest.tipoDocumento = null;
    this.formRequest.dataRiferimento = new Date().getTime();
    this.formRequest.provenienza = null;
    this.formRequest.tipoVisibilitaDocumento  = null;
    // prevalorizzazione da censimento documenti
    if(!!this.isCensimentoDocumenti && this.requestCensimentoDocumenti) {
      this.formRequest.tipoDocumento = this.requestCensimentoDocumenti.tipoDocumento;
      this.formRequest.provenienza = this.requestCensimentoDocumenti.tipoProvenienzaDocumento;
      this.fileUploadList = new Array<DocumentoAllegato>();
    }

    if(entity && entity.tipoAtto){
      this.provenienzaAtto = entity.provenienza;
      this.helperServices.getTipoDocumenteFromTipoAtto(entity.tipoAtto.label).subscribe(res => {
        this.tipoAtto = res[0];
        this.formRequest.tipoDocumento = this.tipoAtto
      })
      this.formRequest.provenienza = this.provenienzaAtto;
    }
    // this.fileUploadList = new Array<DocumentoAllegato>();
    if (this.isFolder) {
      this.editNameDir = false; // new name directory
      if (this.documento) {
        this.editNameDir = true; // edit name directory
        this.formRequest.nomeFile = this.documento.nomeFile.split(this.separatorePathLogico).slice(-1)[0];
      }
      this.aggiungiDocumentoForm = this.campiForm.group({
        nomeFile: [this.formRequest.nomeFile, Validators.required]
      });
    } else {
      this.aggiungiDocumentoForm = this.campiForm.group({
        titolo: [this.formRequest.titolo, Validators.required],
        provenienza: [this.formRequest.provenienza],
        tipoDocumento: [this.formRequest.tipoDocumento, Validators.required],
        tipoVisibilitaDocumento: [this.formRequest.tipoVisibilitaDocumento, Validators.required],
        contentType: [this.formRequest.contentType],
        dataRiferimento: [this.formRequest.dataRiferimento, Validators.required],
        note: [this.formRequest.note],
        fileupload: [''],
        nomeFile: [this.formRequest.nomeFile],
        flagOcr: [this.formRequest.flagOcr],
      });
    }
    // this.uploadUtilityService.tipoProduttoreChanges.subscribe(value => {
    //   this.fileUploadList.forEach(f => {
    //     f.metadatoDocumento = {
    //       ...f.metadatoDocumento,
    //       tipoUfficioProduttore: this.mapToTipoTipologica(value.value)
    //     };
    //   });
    // });
    this.setDefaultProvenienza();
    this.setDefaultVisibilitaDocumento();
  }

  refDocumentaleList = new Array<any>();
  nomeFileList = new Array<any>();
  contentTypeList = new Array<any>();
  fileUploadList: DocumentoAllegato[] = [];
  itemSelected: FileFolders = null;
  separatorePathLogico: string = '';
  isFolder: boolean = false;
  documento: DocumentoAllegato = null;
  tipoPratica: string = '';

  setFileDataRequest(fileData: FileData) {
    let fileDaAllegare = new DocumentoAllegato();
    console.log('fileData',fileData)
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    fileDaAllegare.signedData = fileData.signedData ?? null;
    fileDaAllegare.algoritmoImprontaDocumento = fileData.algoritmoImprontaDocumento;
    fileDaAllegare.improntaDocumento = fileData.improntaDocumento;
    fileDaAllegare.metadatoDocumento = {
      modalitaFormazioneDocumento: { id: 'A', descrizione: '', label: '', rimosso: false },
      tipoUfficioProduttore: { id: 'ESTERNO', descrizione: '', label: '', rimosso: false }
    };
    this.fileUploadList.push(fileDaAllegare);
    console.log(this.fileUploadList)
    this.disableSubmit = false;
    /*
    this.refDocumentaleList.push(fileData.refDocumentale);
    this.nomeFileList.push(fileData.nomeFile);
    this.contentTypeList.push(fileData.contentType);
    */
  }

  setActiveTab(isSearch: boolean) {
    setTimeout(() => {
      this.isSearchTabActive = isSearch;
      this.resetFields();
    });
  }

  public setTextEmpty() {
    if(this.searchItemRef){
      this.searchItemRef.nativeElement.value = '';
    }
  }

  reset(){
    let currentDataRiferimento = new Date().getTime();
    if(this.provenienzaAtto || this.tipoAtto){
      this.formRequest = new DocumentoAllegato(this.provenienzaAtto, this.tipoAtto);
      this.fileUploadList = [];
    }
    else if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
    else{
      this.aggiungiDocumentoForm.reset();
      this.fileUploadList = [];
      this.formRequest.provenienza = null;
      this.formRequest.tipoDocumento = null;
      this.aggiungiDocumentoForm.controls['provenienza'].setValue(null);
      this.aggiungiDocumentoForm.controls['tipoDocumento'].setValue(null);
    }

    this.formRequest.dataRiferimento = currentDataRiferimento;
    this.aggiungiDocumentoForm.controls['dataRiferimento'].setValue(currentDataRiferimento);
    this.formRequest.tipoVisibilitaDocumento = null;
    this.setDefaultVisibilitaDocumento();
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
  }

  resetFields(): void {
    this.createForm();
  }

 doImport(response: ProtocolFindFascicoloRequest) {
    this.dialogRef.close(response);
    let obj = {action: "IMPORT", response: response};
    this.dialogRef.close(obj);
    closeModal('docAddModal');
    this.viewManager.updateDocumentazione(response.documenti);
    this.viewManager.updateIntestazione();
  }


  save() {
    if (!this.fileUploadList.length) return;

    const files = this.fileUploadList
      .splice(0, this.fileUploadList.length)
      .map(f => this.enrichFile(f));

    forkJoin(files.map(f => this.saveOperation(f).pipe(map(res => ({ res, file: f }))))).subscribe(results => {
      this.handleSaveResponse(results)
    });
  }

  private enrichFile(file: DocumentoAllegato): DocumentoAllegato {
    return {
      ...file,
      titolo: this.formRequest.titolo ? this.formRequest.titolo.trim() : '',
      tipoDocumento: this.formRequest.tipoDocumento,
      dataRiferimento: this.formRequest.dataRiferimento,
      provenienza: this.formRequest.provenienza || null,
      flagOcr: this.formRequest.flagOcr,
      tipoVisibilitaDocumento: this.formRequest.tipoVisibilitaDocumento,
      ...(this.formRequest.note ? { note: '' + this.formRequest.note } : {})
    };
  }


  deleteFilexport(){
    this.fileExport = [];
  }

  saveDir() {
    const obj = new DocumentoAllegato();
    obj.nomeFile = this.formRequest.nomeFile;
    obj.titolo = this.formRequest.nomeFile;
    obj.dataRiferimento = new Date().getTime();
    obj.tipoDocumento = this.tipiDocumento.find(el => el.label === 'VARIE');
    obj.provenienza = this.tipiProvenienza.find(el => el.label === 'INTERNO');
    this.saveDirName(obj, this.editNameDir);
  }

  checkNameFile() {
    if (this.formRequest.nomeFile) {
      return !!this.formRequest.nomeFile.includes(this.separatorePathLogico);
    } else {
      return false;
    }
  }

  deleteFileToDocumentaleCallback() {
    this.operationService.deleteFile(this.formRequest.refDocumentale).subscribe(response => this.resetFileToUpload(response));
    this.disableSubmit = true;
  }

  resetFileToUpload(response) {
    if (response.resultCode === 'OK') {
      let fileDaAllegare = new DocumentoAllegato();
    }
  }

  onExtractArchive(event: {response: any, refDocumentale:string}) {
    const documenti: FileData[] = event.response.filesData;
    for (const element of documenti) {
      this.setFileDataRequest(element);
    }
    // rimuove lo zip
    let index = this.fileUploadList.findIndex(x => x.refDocumentale === event.refDocumentale);
    this.fileUploadList.splice(index, 1);
  }


   onDocReturn(event: any) {
      if (!event || !event.refDocumentale) return;
      console.log('event',event);
      const idx = this.fileUploadList.findIndex(f => f.refDocumentale === event.refDocumentale);
      if (idx === -1) return;
      const nuovoMetadato: MetadatoDocumento = {
        modalitaFormazioneDocumento: this.mapToTipoTipologica(
          event.modalitaFormazioneDocumento ?? 'A'
        ),
        motivoAssenzaFirma: this.mapToTipoTipologica(event.motivoAssenzaFirma),
        documentoUnico: event.documentoUnico,
        tipoUfficioProduttore: this.mapToTipoTipologica(
          event.tipoUfficioProduttore ?? 'ESTERNO'
        ),
        ufficioProduttore: event.ufficioProduttore,
        numDocumentiScansione: event.numDocumentiScansione,
        documentiScansionati: event.documentiScansionati
      };
      this.fileUploadList[idx].metadatoDocumento = nuovoMetadato;
      this.fileUploadList = [...this.fileUploadList];
  }
  mapToTipoTipologica = (key?: string): TipoTipologica | undefined => {
    if (!key) return undefined;
    return { id: key, descrizione: '', label: '', rimosso: false };
  };

  /*salvaFile(content, fileName){
    var FileSaver = require('file-saver');
    console.log(content);
    const file = new Blob([content], {type: 'application/octet-stream'});
    FileSaver.saveAs(file, fileName);
  }*/

    private setDefaultVisibilitaDocumento(): void {
      if (
        !this.formRequest?.tipoVisibilitaDocumento &&
        this.tipiVisibilitaDocumento?.length
      ) {
        const pubblico = this.tipiVisibilitaDocumento
          .find(v => v.label?.toUpperCase() === 'PUBBLICO');

        if (pubblico) {
          this.formRequest.tipoVisibilitaDocumento = pubblico;
          this.aggiungiDocumentoForm
            ?.get('tipoVisibilitaDocumento')
            ?.setValue(pubblico);
        }
      }
    }

    get canSave(): boolean {
      // campi obbligatori del form principale
      if (
        !this.formRequest?.titolo ||
        !this.formRequest?.provenienza ||
        !this.formRequest?.tipoDocumento ||
        !this.formRequest?.dataRiferimento ||
        !this.formRequest?.tipoVisibilitaDocumento
      ) {
        return false;
      }

      // almeno un file
      if (!this.fileUploadList?.length) return false;
      // tutti i file devono avere i metadati obbligatori
      return this.fileUploadList.every(file =>
        file.metadatoDocumento &&
        file.metadatoDocumento.tipoUfficioProduttore
      );
    }


  abstract saveOperation(request: DocumentoAllegato);
  abstract saveDirName(request: DocumentoAllegato, editNameDir: boolean);
  abstract handleSaveResponse(results: Array<{ res: any; file: DocumentoAllegato }>): void;
}
